var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPerson48Filled = function SvgIconPerson48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.999 24.7a7.7 7.7 0 1 0 0-15.4 7.7 7.7 0 0 0 0 15.4ZM37.7 31.6a5.3 5.3 0 0 0-5.3-5.3H15.63a5.3 5.3 0 0 0-5.3 5.3V37h27.4l-.03-5.4Z",
    fill: "current"
  })));
};
export default SvgIconPerson48Filled;